var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-telephone"},[_c('edit',{attrs:{"fs":_vm.fs,"api":"settings","id":"telephone","title":"Telephone Setting"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }